"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _ = require("../");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  scrollX: {
    position: "absolute",
    //        top: "50%",
    //        transform: "translateY(-50%)",
    top: 0,
    right: 0,
    bottom: "auto",
    left: 0,
    overflowX: "scroll" //        display: "flex",
    //        alignItems: "center",
    //        justifyContent: "center"

  },
  gridX: {
    display: "flex",
    alignItems: "center"
  },
  scrollY: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflowY: "scroll"
  },
  gridY: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center"
  }
}));

const AppsWidget = (_ref) => {
  let _ref$apps = _ref.apps,
      apps = _ref$apps === void 0 ? [] : _ref$apps,
      props = _objectWithoutPropertiesLoose(_ref, ["apps"]);

  const classes = useStyles();
  const grid = props && props.size.split(':');
  const rows = grid && grid[1];
  let size, orientation;

  if (rows < 2) {
    orientation = "x";
    size = "small";
  } else if (rows >= 3) {
    orientation = "y";
  }

  if (orientation === "y") {
    return _react.default.createElement(_.WidgetBase, props, _react.default.createElement("div", {
      className: classes.scrollY
    }, _react.default.createElement(_.AppsGrid, {
      size: size,
      className: classes.gridY,
      apps: apps
    })));
  }

  return _react.default.createElement(_.WidgetBase, props, _react.default.createElement("div", {
    className: classes.scrollX
  }, _react.default.createElement(_.AppsGrid, {
    size: size,
    className: classes.gridX,
    apps: apps
  })));
};

AppsWidget.defaultProps = {
  size: "16:2"
};
var _default = AppsWidget;
exports.default = _default;
module.exports = exports.default;